import { Box, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import BriaFaqSection from "../../../components/common/BriaFaqSection/BriaFaqSection";
import AttributionArchitectureCard from "./components/AttributionArchitectureCard/AttributionArchitectureCard";
import styles from "./ModelsAttributionAgent.module.scss";
import { getAttributionServiceFaqs } from "./ModelsAttributionAgentFaqs";

const ModelsAttributionAgent = () => {
	const { t } = useTranslation("translation", { keyPrefix: "models.attributionService" });
	const faqItems = getAttributionServiceFaqs(t);

	return (
		<Box className={styles.container}>
			<Box className={styles.content}>
				{/* What is the Attribution Service section */}
				<Box className={styles.section}>
					<Typography variant="h4" className={styles.sectionTitle}>
						{t("header.title")}
					</Typography>
					<Typography className={styles.description} dangerouslySetInnerHTML={{ __html: t("header.description") }} />

					<Typography variant="h4" className={styles.sectionSubTitle}>
						{t("chooseArchitecture.title")}
					</Typography>

					<Box className={styles.architectureCards}>
						<AttributionArchitectureCard type="fullPrivacy" />
						<AttributionArchitectureCard type="noComputeCost" />
					</Box>
				</Box>
			</Box>

			{/* FAQ section */}
			<BriaFaqSection
				title={t("faq.title")}
				faqItems={faqItems}
				className={styles.faqSection}
				titleClassName={styles.faqSectionTitle}
			/>
		</Box>
	);
};

export default observer(ModelsAttributionAgent);
